import { useEffect, useState } from 'react';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";
import { getBankdetal, SaveBankdetails } from '../../Services/Service';


const BankDetail = () => {
  const [loading, setLoading] = useState(false);

  const [BankformData, setBankFormData] = useState({
    Accountno: '',
    BranchName: '',
    IFSCCode: '',
    BankCode: '',
    NameOnPanCard: '',
    AccountHoldername: '',
    BranchCode: '',
    Bankname: '',
    PanNumber: '',
    ServiceTaxNo: ''
  });

  useEffect(() => {
    const getBankdetails = async () => {
      setLoading(true);
      try {
        const result = await getBankdetal();
        if (result && result.length > 0) {
          setBankFormData(result[0]);
        }
      }
      catch (error) {
        console.log("error get bank details", error);
      } finally {
        setLoading(false);
      }
    }
    getBankdetails();
  }, []);


  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await SaveBankdetails(BankformData);
      console.log("Saved bank details:", response);      
      swal("Bank details saved successfully!", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      });
    } catch (error) {
      console.error("Failed to save bank details:", error);
      alert("Failed to save bank details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">

              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Bank Details</div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">

                          <div className="col-6 mb-3">
                            <label className="col-form-label">Account Number</label>
                            <input type="text" className="form-control" placeholder="Enter Account No" value={BankformData.Accountno} onChange={(e) => setBankFormData({ ...BankformData, Accountno: e.target.value })} required />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">Account Holder Name</label>
                            <input type="text" className="form-control" placeholder="Enter Holder Name" value={BankformData.AccountHoldername} onChange={(e) => setBankFormData({ ...BankformData, AccountHoldername: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">Branch Name</label>
                            <input type="text" className="form-control" placeholder="Enter Branch Name" value={BankformData.BranchName} onChange={(e) => setBankFormData({ ...BankformData, BranchName: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">IFSC Code</label>
                            <input type="text" className="form-control" placeholder="Enter IFSC Code" value={BankformData.IFSCCode} onChange={(e) => setBankFormData({ ...BankformData, IFSCCode: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">Branch Code</label>
                            <input type="text" className="form-control" placeholder="Enter Branch Code" value={BankformData.BranchCode} onChange={(e) => setBankFormData({ ...BankformData, BranchCode: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">Bank Name</label>
                            <input type="text" className="form-control" placeholder="Enter Bank Name" value={BankformData.Bankname} onChange={(e) => setBankFormData({ ...BankformData, Bankname: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">Bank Code</label>
                            <input type="text" className="form-control" placeholder="Enter Bank Code" value={BankformData.BankCode} onChange={(e) => setBankFormData({ ...BankformData, BankCode: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">PAN Number</label>
                            <input type="text" className="form-control" placeholder="Enter PAN Number" value={BankformData.PanNumber} onChange={(e) => setBankFormData({ ...BankformData, PanNumber: e.target.value })} />
                          </div>
                          <div className="col-6 mb-3">
                            <label className="col-form-label">Name on PAN Card</label>
                            <input type="text" className="form-control" placeholder="Enter Name on PAN Card" value={BankformData.NameOnPanCard} onChange={(e) => setBankFormData({ ...BankformData, NameOnPanCard: e.target.value })} />
                          </div>

                          <div className="col-6 mb-3">
                            <label className="col-form-label">Service Tax No</label>
                            <input type="text" className="form-control" placeholder="Enter Service Tax No" value={BankformData.ServiceTaxNo} onChange={(e) => setBankFormData({ ...BankformData, ServiceTaxNo: e.target.value })} />
                          </div>
                        </div>


                        <div className="card-action text-end">
                          <button type="submit" className="btn btn-black">Submit</button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        
      </div>
    </>

  );
};

export default BankDetail;